import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap-modal'
import { useForm } from 'react-hook-form'
import TextInputWrapper from './text-input-wrapper'
import SelectInputWrapper from './select-input-wrapper'
import TextAreaWrapper from './text-area-wrapper'
import { ajaxGet, patchForm } from '../../../ajax'
import FlashAlert from '../../../components/flash-alert'

const FacilityModal = props => {
  const [facility, setFacility] = useState()
  const [alert, setAlert] = useState()
  const [isLoading, setIsLoading] = useState(true)

  const { register, reset, setValue, handleSubmit, formState: { errors } } = useForm()

  const paymentTypes = [
    '', 'Daily', 'Weekly', 'Monthly', 'Pending Payment', 
    'CC', 'CC Pending', 'Melio', 'Zelle', 'Bi-Weekly'
  ]

  const onSubmit = (data) => {
    let formData = new FormData()
    for (const key in data) { if (data[key] != null) formData.append(`location[${key}]`, data[key]) }

    patchForm(`/admins/locations/${props.locationId}.json`, formData)
    .then(response => { return response.json() })
    .then(json => {
      if (json.alert)
        setAlert(json.alert)
      else {
        props.onClose()
        props.onLocationUpdate(json.location)
      }
    })
  }

  useEffect(() => {
    loadFacility()
  }, [])

  useEffect(() => {
    if (facility) reset(_.omit(facility, 'id', 'region', 'logo_url'))
  }, [facility])

  const loadFacility = () => {
    ajaxGet(`/admins/locations/${props.locationId}/edit.json`)
    .then(response => { if (response.ok) return response.json() })
    .then(json => {
      setFacility(json.location)
      setIsLoading(false)
    })
  }

  return (
    <Modal dialogClassName={`facility-modal ${isLoading ? ' isLoading' : ''}`} container={document.body} show={true} onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Facility</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { isLoading && <div className='animated-spinner' /> }
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
        <form className='form-horizontal' onSubmit={handleSubmit(onSubmit)}>
          <div className='row'>
            <div className='col-lg-8'>
              <TextInputWrapper
                {...register('name')}
                label='Name'
                disabled={true}
              />
              <TextInputWrapper
                {...register('email')}
                label='Contact Email'
                onChange={e => setValue('email', e.target.value)}
              />
              <TextInputWrapper
                {...register('region_name')}
                label='Region'
                disabled={true}
              />
              <SelectInputWrapper
                {...register('payment_type')}
                label='Payment type'
                options={paymentTypes}
                defaultValue={facility && facility.payment_type}
                onChange={e => setValue('payment_type', e.target.value)}
              />
            </div>
            <div className='col-lg-4'>
              <div className='logo-wrapper'>
                <img loading='lazy' className='facility-logo' src={facility && facility.logo_url} />
              </div>
            </div>
            <div className='col-lg-12'>
              <TextAreaWrapper 
                readOnly
                {...register('commission_notes')}
                label='Facility Commission Notes'
                name='commission_notes'
                rows='5'
                className='form-control'
              />
            </div>
            <div className='col-lg-12'>
              <TextAreaWrapper 
                {...register('notes')}
                label='Notes'
                name='notes'
                rows='5'
                className='form-control'
                onChange={e => setValue('notes', e.target.value)}
              />
            </div>
            <div className='col-lg-8'>
              <div className='form-group row'>
                <div className='col-lg-3'>
                  <input type='submit' value='Save' className='btn btn-primary' />
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default FacilityModal
